export function  setCookie(c_name,value,expiredays) {
  var exdate=new Date();
  exdate.setDate(exdate.getDate()+expiredays);
  document.cookie=c_name+ "=" +escape(value)+
    ((expiredays==null) ? "" : ";expires="+exdate.toGMTString());
}

export function getCookie(key){
  var arr1 = document.cookie.split('; ');
  for(var i = 0;i< arr1.length;i++){
    var arr2 = arr1[i].split('=');
    if(arr2[0] == key){
      return arr2[1];
    }
  }
  return "";
}

export function removeCookie(key){
  setCookie(key,'',-1);
}



// 检测是否为银河麒麟系统（或需要使用后端TTS的Linux系统）
export function isKylinOS() {
  const userAgent = navigator.userAgent.toLowerCase();
  const platform = navigator.platform.toLowerCase();
  
  // 方法1: 检测 User Agent 中的麒麟标识
  if (userAgent.includes('kylin') || userAgent.includes('neokylin')) {
    console.log('检测到银河麒麟系统（通过UA标识）');
    return true;
  }
  
  // 方法2: 检测 Linux 系统
  // 银河麒麟基于 Linux，User Agent 包含 'X11; Linux x86_64'
  if (platform.includes('linux') || (userAgent.includes('linux') && userAgent.includes('x11'))) {
    console.log('检测到Linux系统，将使用后端TTS接口');
    return true;
  }
  
  return false;
}

// TTS播放队列（用于银河麒麟系统）
const ttsQueue = [];
let isPlayingTTS = false;

// 处理TTS队列
function processTTSQueue() {
  if (isPlayingTTS || ttsQueue.length === 0) {
    return;
  }
  
  isPlayingTTS = true;
  const nextTask = ttsQueue.shift();
  
  nextTask().then(() => {
    isPlayingTTS = false;
    processTTSQueue(); // 播放下一条
  }).catch(error => {
    console.error('TTS播放失败:', error);
    isPlayingTTS = false;
    processTTSQueue(); // 继续播放下一条
  });
}

// 调用后端TTS接口播报（用于银河麒麟系统）
// 内部实际播放函数
function playReadByTTSInternal(msg) {
  return new Promise((resolve, reject) => {
    // 动态导入request，避免循环依赖（使用命名导出）
    import('@/utils/request').then(({ request }) => {
      request({
        url: window.g.ttsUrl || '/device-service/alarm/real-time/tts',
        method: 'post',
        data: {
          text: msg
        },
        responseType: 'blob' // 重要：告诉axios返回的是二进制数据
      }).then(response => {
        // 创建音频播放
        const audioBlob = new Blob([response], { type: 'audio/mpeg' });
        const audioUrl = URL.createObjectURL(audioBlob);
        const audio = new Audio(audioUrl);
        
        // 保存到全局变量，以便控制播放
        window.currentAudio = audio;
        
        audio.onended = () => {
          URL.revokeObjectURL(audioUrl); // 释放内存
          window.currentAudio = null;
          resolve();
        };
        
        audio.onerror = (error) => {
          console.error('音频播放失败:', error);
          URL.revokeObjectURL(audioUrl);
          window.currentAudio = null;
          reject(error);
        };
        
        audio.play().catch(error => {
          console.error('音频播放失败:', error);
          window.currentAudio = null;
          reject(error);
        });
      }).catch(error => {
        console.error('TTS接口调用失败:', error);
        reject(error);
      });
    }).catch(error => {
      console.error('导入request模块失败:', error);
      reject(error);
    });
  });
}

// 对外暴露的TTS播放函数（带队列机制）
export function playReadByTTS(msg) {
  // 将播放任务加入队列
  ttsQueue.push(() => playReadByTTSInternal(msg));
  
  // 触发队列处理
  processTTSQueue();
  
  // 立即返回，模拟原生speechSynthesis的行为
  return Promise.resolve();
}

// eslint-disable-next-line no-unused-vars
export function playRead(msg){
  // 如果是银河麒麟系统，使用后端TTS接口
  if (isKylinOS()) {
    return playReadByTTS(msg);
  }
  
  // 否则使用浏览器原生语音API
  let toSpeak = new SpeechSynthesisUtterance();
  toSpeak.text = msg;     // 文字内容
  toSpeak.lang = "zh-CN";  // 使用的语言:中文
  toSpeak.volume = 1;      // 声音音量：1
  // toSpeak.rate = 1;        // 语速：1
  toSpeak.pitch = 1;       // 音高：1
  // toSpeak.rate = 1.4;// 设置播放语速，范围：0.1 - 10之间
  toSpeak.voiceURI = 'Ting-Ting'

  // eslint-disable-next-line no-undef
  index_synth.speak(toSpeak);
  // console.log("声音播报开始");
}

//暂停
export function pause() {
  if (isKylinOS() && window.currentAudio) {
    window.currentAudio.pause();
  } else {
    // eslint-disable-next-line no-undef
    index_synth.pause();
  }
  // console.log("语音播报暂停");
}

//继续播放
export function resume() {
  if (isKylinOS() && window.currentAudio) {
    window.currentAudio.play();
  } else {
    // eslint-disable-next-line no-undef
    index_synth.resume(); //继续
  }
  // console.log("语音播报继续");

}

//清除所有语音播报创建的队列
export function cancel() {
  if (isKylinOS()) {
    // 银河麒麟系统：停止并清除当前音频
    if (window.currentAudio) {
      window.currentAudio.pause();
      window.currentAudio.currentTime = 0;
      window.currentAudio = null;
    }
    // 清空TTS队列
    ttsQueue.length = 0;
    isPlayingTTS = false;
  } else {
    // eslint-disable-next-line no-undef
    index_synth.cancel();
  }
  // 重置全局语音播放状态
  if (window.app && window.app.isVoicePlaying) {
    window.app.isVoicePlaying = false;
  }
  // console.log("语音播报清除");
}

//判断语音是否在播报
export function speaking() {
  if (isKylinOS()) {
    // 银河麒麟系统：检查音频是否在播放，或队列中还有待播放的任务
    return isPlayingTTS || ttsQueue.length > 0 || (window.currentAudio && !window.currentAudio.paused);
  } else {
    // eslint-disable-next-line no-undef
    return index_synth.speaking;
  }
}


export function findNameById(array, id) {
  console.log(array, id)
  for (let i = 0; i < array.length; i++) {
    if (array[i].value === id) {
      console.log(1)
      return array[i].label;
    } else if (array[i].children && array[i].children.length > 0) {
      const name = findNameById(array[i].children, id);
      if (name) {
        return name;
      }
    }
  }
  return undefined;
}